import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {PageLayoutService, ViewModes} from '@spartacus/storefront';
import {take} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class ViewModeService {

  private subscription = new Subscription();
  private viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);

  constructor(private pageLayoutService: PageLayoutService) {
    this.subscription.add(
      this.pageLayoutService.templateName$.pipe(take(1), untilDestroyed(this)).subscribe(template => {
        this.viewMode$.next(ViewModes.Grid);
      })
    );
  }

  public getViewMode$(): Observable<ViewModes> {
    return this.viewMode$.asObservable();
  }

  public setViewMode(newMode: ViewModes): void {
    this.viewMode$.next(newMode);
  }
}
